const e=".25s",r="1rem",m="0.125rem";export{r as SpacingLg,m as SpacingXxs,e as TransitionDurationDefault};
